import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, MenuItem, Box, Typography } from '@mui/material';
import { UserApi } from '../../../apis'; // Adjust the import path as necessary

// Validation schema using Yup
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  password: Yup.string().required('Password is required').min(8, 'Password should be at least 8 characters long'),
  status: Yup.string().required('Status is required'),
});

function MyForm({ fetchUsers,close }) {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',  // Include password field
      status: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        // Make the API call to create a user
        const response = await UserApi.createUser(values);

        // Optionally reset the form or navigate to another page here
        close()
        await fetchUsers();
      } catch (error) {
        console.error('Error creating user:', error);
        // Handle the error, e.g., show a notification or alert
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        '& .MuiTextField-root': { mb: 2 },
        margin: 'auto',
      }}
    >
      <Typography variant="h7" component="div" gutterBottom>
        Name
      </Typography>
      <TextField
        fullWidth
        id="name"
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
      />

      <Typography variant="h7" component="div" gutterBottom>
        Email
      </Typography>
      <TextField
        fullWidth
        id="email"
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
      />

      <Typography variant="h7" component="div" gutterBottom>
        Password
      </Typography>
      <TextField
        fullWidth
        id="password"
        name="password"
        type="password"
        value={formik.values.password}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
      />

      <Typography variant="h7" component="div" gutterBottom>
        Status
      </Typography>
      <TextField
        fullWidth
        id="status"
        name="status"
        select
        value={formik.values.status}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.status && Boolean(formik.errors.status)}
        helperText={formik.touched.status && formik.errors.status}
      >
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Inactive">Inactive</MenuItem>
      </TextField>

      <Button color="primary" variant="contained" fullWidth type="submit" disabled={loading}>
        {loading ? 'Submitting...' : 'Add'}
      </Button>
    </Box>
  );
}

export default MyForm;
